import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnnouncementApi } from 'src/app/services/api-service/announcement/announcement-api';
import { ChiMedExpireData } from 'src/app/services/api-service/announcement/announcement-model';
import { DateHelper } from 'src/app/shared/helpers/date-helper';

@Component({
  selector: 'app-chi-med-expire-tool',
  templateUrl: './chi-med-expire-tool.component.html',
  styleUrls: ['./chi-med-expire-tool.component.css']
})
export class ChiMedExpireToolComponent implements OnInit {

  @Output()
  close = new EventEmitter();
  data: ChiMedExpireData[] = [];

  constructor(private api:AnnouncementApi) { }

  ngOnInit(): void {
    this.addRow();
  }

  /** 新增一行 */
  addRow() {
    const nextRow: ChiMedExpireData = {
      EndDate: DateHelper.today,
      StdCodes: ''
    };
    this.data = this.data ?? [];
    this.data.push(nextRow);
  }

  /** 移除指定行 */
  deleteRow(i: number) {
    this.data = this.data.filter((_, ind) => ind !== i);
  }

  async Save() {
    await this.api.UpdateSChiRxExpire(this.data.filter(x=>x.StdCodes));
    // placeholder for save workflow
    this.close.emit();
  }
}

